import { useField } from 'formik'
import TextareaAutosize from 'react-textarea-autosize'
import styles from './inputs.module.scss'

const countLines = (value) => (value ? value.split('\n').length : 1)

const CustomTextArea = ({ label, placeholder, spanText, maxLength, noNewLine, maxLines, ...props }) => {
  const [field, meta] = useField(props)
  const customClass = props.className === undefined ? '' : `${props.className  } `
  const charCount = field.value ? field.value.length : 0
  const isOverLimit = maxLength && charCount >= maxLength

  const handleKeyDown = (e) => {
    if (noNewLine && e.key === 'Enter') {
      e.preventDefault()
      return
    }
    if (maxLines && e.key === 'Enter') {
      const lines = countLines(field.value)
      if (lines >= maxLines) e.preventDefault()
    }
  }

  const handlePaste = (noNewLine || maxLines)
    ? (e) => {
        e.preventDefault()
        let text = e.clipboardData.getData('text/plain')
        const input = e.target
        const start = input.selectionStart
        const end = input.selectionEnd
        const current = field.value || ''

        if (noNewLine) {
          text = text.replace(/[\r\n]+/g, ' ')
        } else if (maxLines) {
          // Split paste by lines, only keep up to remaining lines
          const existingLines = current.slice(0, start).split('\n').length
          const remaining = maxLines - existingLines
          text = text.split('\n').slice(0, remaining).join('\n')
        }

        const next = current.slice(0, start) + text + current.slice(end)
        const trimmed = maxLength ? next.slice(0, maxLength) : next
        field.onChange({ target: { name: field.name, value: trimmed } })
      }
    : undefined

  return (
    <div className="d-flex flex-column">
      <span className={styles.label}>{label}</span>
      {spanText && <span className={styles.light}> {spanText}</span>}
      <TextareaAutosize
        {...field}
        placeholder={placeholder}
        className={
          meta.touched && meta.error
            ? customClass + styles.inputError
            : customClass
        }
        minRows={2}
        maxLength={maxLength}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
      />
      {maxLength && (
        <span style={{ fontSize: 11, textAlign: 'right', color: isOverLimit ? '#c0392b' : '#888', marginTop: 2 }}>
          {charCount}/{maxLength}
        </span>
      )}
      {meta.touched && meta.error && (
        <div className={styles.error}>{meta.error}</div>
      )}
    </div>
  )
}

export default CustomTextArea
